module.exports = __webpack_public_path__ + "img/f6.dcc38014.png";